import React, { useMemo } from "react";

import Grid from "@mui/material/Grid";
import { useTheme } from "@mui/material/styles";
import ChevronRight from "Components/Generic/Icons/ChevronRight";
import SkeletonComponent from "Components/Generic/Skeleton";
import { useCustomerPortalJobContext } from "Context/CustomerPortalJobContext";
import { useTranslation } from "react-i18next";
import { handleGetConvertValue, Metric } from "Util/converts";
import { getMeasurement, getWeightMeasurement } from "Util/getMeasurement";

import { useOrderPageTabs } from "../../../../OrderPage";
import {
  InventoryTitle,
  InventoryRedirect,
  InventoryType,
  InventoryValue,
  InventoryCard,
} from "./styled";

export const SummaryInventoriesDetailsSection = () => {
  const { t: translate } = useTranslation();
  const theme = useTheme();
  const { order, isLoading } = useCustomerPortalJobContext();
  const { setCurrentTab } = useOrderPageTabs();

  const measurement = getMeasurement();
  const weightMeasurement = getWeightMeasurement();

  const volumeConversor = useMemo(() => {
    return (value: number) =>
      `${handleGetConvertValue(value, measurement?.code, measurement?.decimalPlaces)} ${
        measurement?.code || Metric["m³"]
      }`.trim();
  }, [measurement]);

  const weightConversor = useMemo(() => {
    return (value: number) =>
      `${handleGetConvertValue(value, weightMeasurement?.code, weightMeasurement?.decimalPlaces)} ${
        weightMeasurement?.code || Metric.kg
      }`.trim();
  }, [weightMeasurement]);

  const getLabel = (volume = 0, weight = 0, quantity = 0) => {
    const quantityLabel = `${quantity} ${translate(quantity > 1 ? "items" : "item")}`;

    return `${quantityLabel} / ${volumeConversor(volume)} / ${weightConversor(weight)}`;
  };

  return (
    <>
      <InventoryCard container direction="column" flexWrap={"nowrap"}>
        <Grid
          item
          xs={12}
          container
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          marginBottom="4px"
        >
          <Grid item xs={6}>
            <InventoryTitle>{translate("inventories")}</InventoryTitle>
          </Grid>
          <Grid item xs={6} display="flex" justifyContent="flex-end">
            <InventoryRedirect
              onClick={() => {
                setCurrentTab(1);
              }}
            >
              {translate("checkMyInventories")}
              <ChevronRight
                color={theme.palette.primary.main}
                height={16}
                width={16}
                heightBoxView={20}
                widthBoxView={20}
              />
            </InventoryRedirect>
          </Grid>
        </Grid>
        <SkeletonComponent isLoading={isLoading}>
          <Grid item xs={12} container direction="row">
            <Grid item xs>
              <InventoryType>{translate("asQuoted")}:</InventoryType>
              <InventoryValue>
                {getLabel(
                  order?.inventories?.quoted?.totalVolume,
                  order?.inventories?.quoted?.totalWeight,
                  order?.inventories?.quoted?.totalQuantity
                )}
              </InventoryValue>
              <InventoryType>•</InventoryType>
              <InventoryType>{translate("actual")}:</InventoryType>
              <InventoryValue>
                {getLabel(
                  order?.inventories?.actual?.totalVolume,
                  order?.inventories?.actual?.totalWeight,
                  order?.inventories?.actual?.totalQuantity
                )}
              </InventoryValue>
            </Grid>
          </Grid>
        </SkeletonComponent>
      </InventoryCard>
    </>
  );
};
